import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { InputValue } from '../inputmodels/inputvalue.model';

import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { KindBoard } from 'src/utils/enums';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-quantity',
    templateUrl: './inputquantity.component.html',
    styleUrls: ['./inputquantity.component.css'],
    standalone: false
})
export class InputQuantityComponent extends PageBase implements OnInit, OnChanges {

  @Input() inputQuantity: InputValue = new InputValue();
  @Input() isHideLoading: boolean;
  graphicOpacity = 1;
  calculoSaldoInsumo: string;
  inputItem: InputItem = new InputItem();

  constructor(public contextApplication: ContextApplication,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.resete();
  }

  private resete() {
    this.inputQuantity.id = 0;
    this.inputQuantity.inputQuantityBalance = 0;
    this.inputQuantity.inputCurrency = '';
    this.inputQuantity.unitOfMeasure = '';
    this.inputQuantity.inputValueBalance = 0;
    this.graphicOpacity = 1;
    this.calculoSaldoInsumo = '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputQuantity) {
      this.load();
    }
  }

  async load() {
    if (this.contextApplication.currentVision == KindBoard.Insumo.valueOf()) {
      this.calculoSaldoInsumo = this.literalsCp?.strSaldoInsumo;
    }
    else
    {
      this.calculoSaldoInsumo = this.literalsCp?.strSaldoInsumoTarefa;
    }

    if(typeof(this.inputQuantity.errorList) !== 'undefined' && this.inputQuantity.errorList.length > 0
            && this.inputQuantity.errorList[0].message?.length > 0)
     {
      this.graphicOpacity = 0.1;
     }
  }

  onReceiveLiterals(): void {}

}
